import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-c181760e"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["title"]

import { computed, ref } from "vue";
import { useI18n } from "vue-i18n";

interface Menu {
  id: number;
  linkTo: string;
  linkLabel: string;
  icon?: string;
  children?: Menu[];
  quantity?: number | string | null;
  badge?: number | string | null;
  badgeCount?: number | string | null;
  count?: number | string | null;
  pendingCount?: number | string | null;
}

/** Cap display at 3 digits — larger values show as "999+" */
const BADGE_MAX = 999;

/** Only positive finite numbers are shown; 0 / null / non-numeric → hidden */

export default /*#__PURE__*/_defineComponent({
  __name: 'DashboardMenuItem',
  props: {
    item: {},
    showIcon: { type: Boolean, default: true },
    iconOnly: { type: Boolean, default: false },
    isChild: { type: Boolean, default: false }
  },
  setup(__props: any) {

const parseBadgeCount = (value: unknown): number | null => {
  if (value === null || value === undefined) return null;
  if (typeof value === "boolean" || typeof value === "object") return null;
  if (typeof value === "string") {
    const trimmed = value.trim();
    if (!trimmed || !/^-?\d+(\.\d+)?$/.test(trimmed)) return null;
    const n = Number(trimmed);
    return Number.isFinite(n) && n > 0 ? n : null;
  }
  if (typeof value === "number") {
    return Number.isFinite(value) && value > 0 ? value : null;
  }
  return null;
};

const formatBadgeCount = (n: number): string =>
  n > BADGE_MAX ? `${BADGE_MAX}+` : String(Math.floor(n));

const props = __props;

const { t, te } = useI18n();
const labelRef = ref<HTMLElement | null>(null);
const isOverflow = ref(false);

const labelText = computed(() => {
  const label = props.item.linkLabel?.trim() || "";
  if (!label) return "";
  if (te(label)) return t(label);
  const keyMatch = /^menu\.(.+)$/i.exec(label);
  if (keyMatch) {
    const shortKey = `menu.${keyMatch[1]}`;
    if (te(shortKey)) return t(shortKey);
    const raw = keyMatch[1].replace(/[-_]/g, " ");
    return raw.charAt(0).toUpperCase() + raw.slice(1);
  }
  return label;
});

const tooltipTitle = computed(() => {
  if (props.iconOnly || !isOverflow.value) return "";
  return labelText.value;
});

const iconClass = computed(() => {
  const icon = props.item.icon?.trim();
  if (icon) return icon;
  return props.isChild ? "fa-solid fa-circle" : "fa-solid fa-folder";
});

const badgeRaw = computed(() =>
  parseBadgeCount(
    props.item.quantity ??
      props.item.badge ??
      props.item.badgeCount ??
      props.item.count ??
      props.item.pendingCount
  )
);

const badgeDisplay = computed(() => {
  const n = badgeRaw.value;
  return n == null ? null : formatBadgeCount(n);
});

const badgeTitle = computed(() => {
  const n = badgeRaw.value;
  if (n == null || n <= BADGE_MAX) return undefined;
  return String(Math.floor(n));
});

const checkOverflow = () => {
  const el = labelRef.value;
  if (!el) {
    isOverflow.value = false;
    return;
  }
  isOverflow.value = el.scrollWidth > el.clientWidth + 1;
};

return (_ctx: any,_cache: any) => {
  const _component_a_tooltip = _resolveComponent("a-tooltip")!

  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(["dashboard-menu-item", {
      'dashboard-menu-item--child': _ctx.isChild,
      'dashboard-menu-item--icon-only': _ctx.iconOnly,
    }])
  }, [
    (_ctx.showIcon)
      ? (_openBlock(), _createElementBlock("i", {
          key: 0,
          class: _normalizeClass(['dashboard-menu-item__icon', iconClass.value]),
          "aria-hidden": "true"
        }, null, 2))
      : _createCommentVNode("", true),
    _createVNode(_component_a_tooltip, {
      placement: "top",
      title: tooltipTitle.value,
      "mouse-enter-delay": 0.25,
      "overlay-style": { maxWidth: '280px' }
    }, {
      default: _withCtx(() => [
        _createElementVNode("span", {
          class: "dashboard-menu-item__label-wrap",
          onMouseenter: checkOverflow
        }, [
          _createElementVNode("span", {
            ref_key: "labelRef",
            ref: labelRef,
            class: "dashboard-menu-item__label"
          }, _toDisplayString(labelText.value), 513)
        ], 32)
      ]),
      _: 1
    }, 8, ["title"]),
    (badgeDisplay.value != null)
      ? (_openBlock(), _createElementBlock("span", {
          key: 1,
          class: "dashboard-menu-item__badge",
          title: badgeTitle.value
        }, _toDisplayString(badgeDisplay.value), 9, _hoisted_1))
      : _createCommentVNode("", true)
  ], 2))
}
}

})